import { IonAlert, IonToast } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setShowDocumentPendingModal } from "../../../store/documentShow";
import { selectShowDocumentPending } from "../../../store/documentShow/selectors/selectShowDocumentPending";
import { selectSigners } from "../../../store/documentShow/selectors/selectSigners";
import { setPendingStatus } from "../../../store/documentUpdate";
import { selectPendingStatus } from "../../../store/documentUpdate/selectors/selectPendingStatus";
import { setDocumentPending } from "../../../store/documentUpdate/actions/setDocumentPending";

export const SetDocumentPending: React.FC = () => {
  const dispatch = useDispatch();
  const showAlert = useSelector(selectShowDocumentPending);
  const pendingStatus = useSelector(selectPendingStatus);
  const signers = useSelector(selectSigners);

  return (
    <>
      {signers.length > 0 ? (
        <IonAlert
          isOpen={showAlert}
          onDidDismiss={() => dispatch(setShowDocumentPendingModal(false))}
          header="¿Seguro que quieres enviar a firmar este acuerdo?"
          buttons={[
            "Volver",
            {
              text: "Confirmar",
              handler: (d) => dispatch(setDocumentPending()),
            },
          ]}
        />
      ) : (
        <IonAlert
          isOpen={showAlert}
          onDidDismiss={() => dispatch(setShowDocumentPendingModal(false))}
          header="Este acuerdo no tiene firmantes aún. Por favor agregar firmantes."
          buttons={["Volver"]}
        />
      )}

      <IonToast
        isOpen={pendingStatus === "fulfilled"}
        message="Acuerdo enviado a firmar correctamente"
        position="top"
        onWillDismiss={() => dispatch(setPendingStatus(""))}
        duration={6000}
        color="success"
      />

      <IonToast
        isOpen={pendingStatus === "pending"}
        message="Enviando a firmar..."
        position="top"
        duration={6000}
        color="primary"
      />
    </>
  );
};
